import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [policiesDropdownOpen, setPoliciesDropdownOpen] = useState(false);
  const servicesRef = useRef(null);
  const policiesRef = useRef(null);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  // Close dropdown after delay when mouse leaves
  const closeServicesDropdown = () => {
    setTimeout(() => {
      setServicesDropdownOpen(false);
    }, 500);
  };
  const closePoliciesDropdown = () => {
    setTimeout(() => {
      setPoliciesDropdownOpen(false);
    }, 500);
  };
  // Cancel closing if mouse re-enters dropdown area
  const cancelServicesClose = () => {
    clearTimeout(servicesRef.current);
  };
  const cancelPoliciesClose = () => {
    clearTimeout(policiesRef.current);
  };
  return <header className="bg-white shadow-md w-full" data-id="element-116">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-117">
        <Link to="/" className="flex items-center" data-id="element-118">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hDXV1rDXM1m2ARqkQ9Hg8F/Medico_Favicon.png" alt="Medicolegal Psychiatry Logo" className="h-12 w-auto" data-id="element-119" />
          <div className="ml-3" data-id="element-120">
            <h1 className="text-primary font-serif text-xl font-bold" data-id="element-121">
              Medicolegal Psychiatry
            </h1>
            <p className="text-slate text-xs" data-id="element-122">Clarity, Compassion, Expertise</p>
          </div>
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-8" data-id="element-123">
          <Link to="/" className="text-primary hover:text-primary-light font-medium transition-colors duration-200 hover:border-b-2 hover:border-primary pb-1" data-id="element-124">
            Home
          </Link>
          <Link to="/about" className="text-primary hover:text-primary-light font-medium transition-colors duration-200 hover:border-b-2 hover:border-primary pb-1" data-id="element-125">
            About Dr. Syed
          </Link>
          {/* Services Dropdown */}
          <div className="relative group" data-id="element-126">
            <button className="flex items-center text-primary hover:text-primary-light font-medium transition-colors duration-200 hover:border-b-2 hover:border-primary pb-1" onMouseEnter={() => setServicesDropdownOpen(true)} onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)} data-id="element-127">
              Our Services <ChevronDown className="ml-1 h-4 w-4" data-id="element-128" />
            </button>
            <div className={`absolute left-0 mt-2 w-64 bg-white shadow-lg rounded-md py-2 z-50 transition-opacity duration-300 ${servicesDropdownOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`} onMouseEnter={() => {
            setServicesDropdownOpen(true);
            cancelServicesClose();
          }} onMouseLeave={() => closeServicesDropdown()} data-id="element-129">
              <Link to="/services" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-colors duration-200" data-id="element-130">
                All Services
              </Link>
              <Link to="/services/mental-capacity" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-colors duration-200" data-id="element-131">
                Mental Capacity Assessments
              </Link>
              <Link to="/services/trauma-ptsd" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-colors duration-200" data-id="element-132">
                Trauma & PTSD Evaluations
              </Link>
              <Link to="/services/neurodevelopmental" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-colors duration-200" data-id="element-133">
                Neurodevelopmental Assessments
              </Link>
              <Link to="/services/forensic-risk" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-colors duration-200" data-id="element-134">
                Forensic & Risk Assessments
              </Link>
              <Link to="/services/specialist" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-colors duration-200" data-id="element-135">
                Specialist Psychiatric Evaluations
              </Link>
            </div>
          </div>
          <Link to="/faq" className="text-primary hover:text-primary-light font-medium transition-colors duration-200 hover:border-b-2 hover:border-primary pb-1" data-id="element-136">
            FAQs
          </Link>
          <Link to="/contact" className="text-primary hover:text-primary-light font-medium transition-colors duration-200 hover:border-b-2 hover:border-primary pb-1" data-id="element-137">
            Contact Us
          </Link>
          {/* Policies Dropdown */}
          <div className="relative group" data-id="element-138">
            <button className="flex items-center text-primary hover:text-primary-light font-medium transition-colors duration-200 hover:border-b-2 hover:border-primary pb-1" onMouseEnter={() => setPoliciesDropdownOpen(true)} onClick={() => setPoliciesDropdownOpen(!policiesDropdownOpen)} data-id="element-139">
              Policies <ChevronDown className="ml-1 h-4 w-4" data-id="element-140" />
            </button>
            <div className={`absolute right-0 mt-2 w-64 bg-white shadow-lg rounded-md py-2 z-50 transition-opacity duration-300 ${policiesDropdownOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`} onMouseEnter={() => {
            setPoliciesDropdownOpen(true);
            cancelPoliciesClose();
          }} onMouseLeave={() => closePoliciesDropdown()} data-id="element-141">
              <Link to="/policies/cancellation" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-colors duration-200" data-id="element-142">
                Cancellation Policy
              </Link>
              <Link to="/policies/privacy" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-colors duration-200" data-id="element-143">
                Privacy & Cookie Policy
              </Link>
              <Link to="/policies/terms" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-colors duration-200" data-id="element-144">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </nav>
        {/* Mobile Menu Button */}
        <button className="lg:hidden text-primary" onClick={toggleMenu} data-id="element-145">
          {isMenuOpen ? <X className="h-6 w-6" data-id="element-146" /> : <Menu className="h-6 w-6" data-id="element-147" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="lg:hidden bg-white pb-4 px-4" data-id="element-148">
          <Link to="/" className="block py-2 text-primary font-medium hover:text-primary-light" onClick={toggleMenu} data-id="element-149">
            Home
          </Link>
          <Link to="/about" className="block py-2 text-primary font-medium hover:text-primary-light" onClick={toggleMenu} data-id="element-150">
            About Dr. Syed
          </Link>
          <div className="py-2" data-id="element-151">
            <button className="flex items-center text-primary font-medium w-full justify-between hover:text-primary-light" onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)} data-id="element-152">
              Our Services{' '}
              <ChevronDown className={`h-4 w-4 transition-transform ${servicesDropdownOpen ? 'rotate-180' : ''}`} data-id="element-153" />
            </button>
            {servicesDropdownOpen && <div className="pl-4 mt-1 space-y-1" data-id="element-154">
                <Link to="/services" className="block py-1 text-primary hover:text-primary-light" onClick={toggleMenu} data-id="element-155">
                  All Services
                </Link>
                <Link to="/services/mental-capacity" className="block py-1 text-primary hover:text-primary-light" onClick={toggleMenu} data-id="element-156">
                  Mental Capacity Assessments
                </Link>
                <Link to="/services/trauma-ptsd" className="block py-1 text-primary hover:text-primary-light" onClick={toggleMenu} data-id="element-157">
                  Trauma & PTSD Evaluations
                </Link>
                <Link to="/services/neurodevelopmental" className="block py-1 text-primary hover:text-primary-light" onClick={toggleMenu} data-id="element-158">
                  Neurodevelopmental Assessments
                </Link>
                <Link to="/services/forensic-risk" className="block py-1 text-primary hover:text-primary-light" onClick={toggleMenu} data-id="element-159">
                  Forensic & Risk Assessments
                </Link>
                <Link to="/services/specialist" className="block py-1 text-primary hover:text-primary-light" onClick={toggleMenu} data-id="element-160">
                  Specialist Psychiatric Evaluations
                </Link>
              </div>}
          </div>
          <Link to="/faq" className="block py-2 text-primary font-medium hover:text-primary-light" onClick={toggleMenu} data-id="element-161">
            FAQs
          </Link>
          <Link to="/contact" className="block py-2 text-primary font-medium hover:text-primary-light" onClick={toggleMenu} data-id="element-162">
            Contact Us
          </Link>
          <div className="py-2" data-id="element-163">
            <button className="flex items-center text-primary font-medium w-full justify-between hover:text-primary-light" onClick={() => setPoliciesDropdownOpen(!policiesDropdownOpen)} data-id="element-164">
              Policies{' '}
              <ChevronDown className={`h-4 w-4 transition-transform ${policiesDropdownOpen ? 'rotate-180' : ''}`} data-id="element-165" />
            </button>
            {policiesDropdownOpen && <div className="pl-4 mt-1 space-y-1" data-id="element-166">
                <Link to="/policies/cancellation" className="block py-1 text-primary hover:text-primary-light" onClick={toggleMenu} data-id="element-167">
                  Cancellation Policy
                </Link>
                <Link to="/policies/privacy" className="block py-1 text-primary hover:text-primary-light" onClick={toggleMenu} data-id="element-168">
                  Privacy & Cookie Policy
                </Link>
                <Link to="/policies/terms" className="block py-1 text-primary hover:text-primary-light" onClick={toggleMenu} data-id="element-169">
                  Terms & Conditions
                </Link>
              </div>}
          </div>
        </div>}
    </header>;
}